<template>
  <td>
    <input type="text" class="form-control" v-model="element.name">
  </td>
  <td>
  </td>
  <td>
  </td>
  <td></td>
</template>

<script>
export default {
  name: 'OrderLineFlight',
  props: ['element'],
}
</script>

<style>

</style>
